<!--
@create date 2023-7-27
@desc m221.phomemo.com
-->
<template>
  <div class="m221-guide-div">
    <div class="topContainerDivEx">
      <h1>M221 LABEL PRINTER SUPPORT</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/m221_5_5.jpg?v=1683251929"
            style="margin: 10px auto; width: 200px"
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <a style="color: black; font-weight: bold"
              >Phomemo M221 Instruction Manual</a
            >
            <a
              href="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Phomemo_M221_Instruction_EN.pdf?v=1679471707"
              target="_blank"
            >
              ENGLISH</a
            >
            |
            <a
              href="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Phomemo_M221_Instruction_DE.pdf?v=1679471706"
              target="_blank"
              >DEUTSCH</a
            >
            |
            <a
              href="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Phomemo_M221_Instruction_JP.pdf?v=1679471714"
              target="_blank"
              >日本語</a
            >
          </div>
          <p>
            Product registration is no longer necessary. Retain proof of
            purchase for warranty confirmation.
          </p>
          <hr
            style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
            v-show="!isMobile()"
          />
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer">Label Roll Installation</div>
      </div>
      <div class="videosDivE">
        <!--       <div class="leftDiv">
        <img src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Labelife.png?v=1679475208" style="display:block;margin:0 auto;margin-bottom: 10px;margin-top: 26px;width:100px;"/>
        <a class="a-link">Labelife</a>
      </div>
      <div class="centerDiv">
         <a class="downloadBtn" href="https://www.labelife.net/#/download" target="_blank">
           <img src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/LabelifeBtn.png?v=1679469921" style="width: 330px;position:relative;top:0px" />
         </a>
      </div> -->
        <div
          class="rightDiv"
          style="float: left; margin-left: 13%; padding-top: 4%"
        >
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/5_ae612e9e-20db-483c-9065-af7cdd65428b.jpg?v=1683182596"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m221_5_paperroll_a.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">App for Android / iOS</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 2%">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Print_Master.png?v=1679455148"
            style="
              display: block;
              margin: 0 auto;
              margin-bottom: 10px;
              margin-top: 26px;
            "
          />
          <a class="a-link">Print Master</a>
        </div>
        <div class="centerDiv" style="padding-top: 1%">
          <a
            class="downloadBtn"
            href="https://play.google.com/store/apps/details?id=com.project.aimotech.printmaster"
            target="_blank"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/googleBtn.png?v=1679474361"
              style="width: 250px; position: relative; top: 0px"
            />
          </a>
          <br /><br />
          <a
            class="downloadBtn"
            href="https://apps.apple.com/com/app/id1467113436"
            target="_blank"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/iOSbtn2.png?v=1679477802"
              style="width: 218px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/m221VideoPicture.jpg?v=1700182262"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m221_6_print%20master_guide_a.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <!-- <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">
          Great for Bluetooth via Phone(IOS &Android)-Easy to use
        </div>
      </div>
      <div class="videosDivE">
        <div style="padding-left: 12%">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/bluetoothGuide.png?v=1686290953"
            style="margin: 0; cursor: pointer"
            @click="
              () => {
                window.open(
                  'https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/bluetoothGuide.png?v=1686290953'
                );
              }
            "
            title="Click to view the original image"
          />
        </div>
      </div>
    </div> -->

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">Drivers for PC / Mac</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Windows_c4bdbd8d-36be-4370-9649-d8d811361bed.png?v=1679455147"
            style="
              display: block;
              margin: 0 auto;
              margin-bottom: 10px;
              margin-top: 26px;
            "
          />
          <a class="a-link">Windows</a>
        </div>
        <div class="centerDiv">
          <a
            class="downloadBtn"
            href="https://oss.qu-in.life/Tianyi/LabelPrinter-WIN_EN.zip"
            target="_blank"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/WindowsBtn.png?v=1679469921"
              style="width: 330px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/1_4a89a2ad-3495-4359-946c-7e033e2423c2.jpg?v=1683182600"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m221_1_windows_setupguide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
        v-show="isMobile()"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">macOS</a>
        </div>
        <div class="centerDiv">
          <a
            class="downloadBtn"
            href="https://oss.qu-in.life/Tianyi/LabelPrinter-MAC_EN.zip"
            target="_blank"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/MacBtn.png?v=1679469921"
              style="width: 330px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2_9f8df457-093e-484b-897f-7787cac3fe27.jpg?v=1683182585"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m221_2_mac_setupguide_a.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">Software for PC / Mac</div>
      </div>
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/Labelife.png?v=1679475208"
            style="
              display: block;
              margin: 0 auto;
              margin-bottom: 10px;
              margin-top: 26px;
              width: 100px;
            "
          />
          <a class="a-link">Labelife</a>
        </div>
        <div class="centerDiv">
          <a
            class="downloadBtn"
            href="https://www.labelife.net/#/download"
            target="_blank"
          >
            <img
              src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/LabelifeBtn.png?v=1679469921"
              style="width: 330px; position: relative; top: 0px"
            />
          </a>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/3_03e17a05-8253-4684-ac1a-ab8df436f624.jpg?v=1683182599"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/m221_3_labeife_guide_a.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div class="faq-item" v-for="(item, index) in faqDataApp">
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a href="mailto:support@phomemo.com">support@phomemo.com</a>
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+86 15338193665</div>
      <div class="everyRow" style="margin-top: 25px">
        Skype：Phomemo Team-Jessie
      </div>
      <div class="everyRow" style="margin-top: 25px">
        Service time：Mon-Fri 9AM-5PM (EST)
      </div>
    </div>
  </div>
</template>

<script>
const faqDataApp = [
  {
    title:
      "1. Why is my M221 not recognized by the computer after successful driver installation?",
    details: [
      {
        theme:
          "You need to connect M221 to your computer with cable first, and then install the driver.",
      },
    ],
  },
  {
    title: "2. Why the Bluetooth connection fails?",
    details: [
      {
        theme:
          "To connect the Phomemo M221 to your phone/tablet, you MUST first turn on Bluetooth and open Print Master app to connect to M221. It will fail if you connect directly in Bluetooth setting.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "3. Why it prints in blank?",
    details: [
      {
        theme: "It could be for these reasons：",
        imgUrls: [],
      },
      {
        theme:
          "1. The printing paper is upside down<br />- Please refer to the instruction manual: 05.Printer Paper Roll Installation.",
        imgUrls: [],
      },
      {
        theme:
          "2. The print head is damaged<br />- Please contact us for replacement;",
        imgUrls: [],
      },
    ],
  },
  {
    title: "4. Where do I buy refills？",
    details: [
      {
        theme:
          "You can search “Phomemo M221 Labels” or “Phomemo Labels” on Amazon and find original labels for it, or you can find links of labels in detial pages of M221.",
        imgUrls: [],
      },
    ],
  },
  {
    title: "5. Why Print Master app keeps asking for location permission？",
    details: [
      {
        theme: "Note: This app won't collect any of your information.",
        imgUrls: [],
      },
      {
        theme:
          "If you are an Android user, you need to turn on location permission for searching Bluetooth devices to complete Bluetooth connection.",
        imgUrls: [],
      },
      {
        theme:
          "Google has strengthened users privacy policy, and requires users to enable some access permission to use Print Master, since the Android version of devices was updated to 10.0",
        imgUrls: [],
      },
    ],
  },
  {
    title: "6. How do I contact about issues of M221？",
    details: [
      {
        theme: "Please contact us through the following ways.",
        imgUrls: [],
      },
    ],
  },
];
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};

export default {
  name: "M221",
  props: {},
  data() {
    return {
      faqDataApp,
      activeQuestion2: {},
      isMobile,
      window,
      sensorsRecord
    };
  },
  mounted() {
  },
  methods: {
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./m221.less" />



// WEBPACK FOOTER //
// src/view/guides/m221.vue